// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1529":"186297ed","2181":"7cd1565f","2376":"2af1a299","3399":"7cd1565f","4219":"29bc89b5","7224":"7cd1565f","7886":"7cd1565f"}[chunkId] + ".chunk.css";
};